function checkAppVersion() {
    const metaVersion = document.querySelector('meta[name="app-version"]').getAttribute('content');
    const storedVersion = localStorage.getItem('appVersion');

    if (storedVersion !== metaVersion) {
        localStorage.setItem('appVersion', metaVersion);
        window.location.replace(window.location.href);
    }
}

export default checkAppVersion;
